import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

import { getResolvedLanguage, isRtlLanguage } from '../utils/rtl';

export const useRTL = () => {
  const { i18n } = useTranslation();
  const language = getResolvedLanguage(i18n);

  const isRTL = isRtlLanguage(language);
  const dir = isRTL ? 'rtl' : 'ltr';

  useEffect(() => {
    document.documentElement.dir = dir;
    document.documentElement.lang = language;

    if (isRTL) {
      document.documentElement.classList.add('rtl');
    } else {
      document.documentElement.classList.remove('rtl');
    }
  }, [language, dir, isRTL]);

  return { isRTL, dir };
};
